// Dev server (dev.wise.riseplus.tech) — same-origin behind nginx, production
// optimizations on. apiUrl is relative so /api hits the shared Rails api on the
// same https origin; apiFileUrl is empty so HLS URLs (`${apiFileUrl}${hls_url}`)
// stay root-relative (/hls/...) and ride the secure_link cookie. Mirrors
// eazycal/web's environment.dev.ts (the dev-deploy env).
export const environment = {
  appName: "Wise",
  production: false,
  apiUrl: "https://dev.wise.riseplus.tech/api",
  apiFileUrl: "https://dev.wise.riseplus.tech",
  appVersion: "v1.0.0",
  demo: false,

};
